import { TicketTypeConfig } from "./TicketTypeConfig";

export class TicketTypeConfigPostCommand {
    message: TicketTypeConfig;

    constructor(ticketTypeConfig: TicketTypeConfig) {
        this.message = ticketTypeConfig;
    }
}